module.exports = __webpack_public_path__ + "static/img/icon_5.3480807.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/icon/icon_5.png
// module id = ZIMX
// module chunks = 49